import { distinctUntilChanged, Observable } from "rxjs";

import { WrappedAccountCryptographicState } from "@vowkey/sdk-internal";
import { StateProvider } from "@vowkey/state";
import { UserId } from "@vowkey/user-core";

import { ACCOUNT_CRYPTOGRAPHIC_STATE } from "../state-definitions";

import { AccountCryptographicStateService } from "./account-cryptographic-state.service";

export class DefaultAccountCryptographicStateService implements AccountCryptographicStateService {
  constructor(protected stateProvider: StateProvider) {}

  accountCryptographicState$(userId: UserId): Observable<WrappedAccountCryptographicState | null> {
    return this.stateProvider.getUserState$(ACCOUNT_CRYPTOGRAPHIC_STATE, userId).pipe(
      // Sync rewrites unchanged state; each emission makes consumers decrypt the whole vault.
      distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
    );
  }

  async setAccountCryptographicState(
    accountCryptographicState: WrappedAccountCryptographicState,
    userId: UserId,
  ): Promise<void> {
    await this.stateProvider.setUserState(
      ACCOUNT_CRYPTOGRAPHIC_STATE,
      accountCryptographicState,
      userId,
    );
  }

  async clearAccountCryptographicState(userId: UserId): Promise<void> {
    await this.stateProvider.setUserState(ACCOUNT_CRYPTOGRAPHIC_STATE, null, userId);
  }
}
